/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BeautyCosmeticsPerfumeIcon24Solid = forwardRef('BeautyCosmeticsPerfumeIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2.5A1.5 1.5 0 0 1 8.5 1h7A1.5 1.5 0 0 1 17 2.5v2A1.5 1.5 0 0 1 15.5 6H15v2h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h3V6h-.5A1.5 1.5 0 0 1 7 4.5v-2Zm5 15.75c2.761 0 5-1.455 5-3.25s-2.239-3.25-5-3.25S7 13.205 7 15s2.239 3.25 5 3.25Z" })));
});
